import { LazyPageLoading } from '@components/lazy-page-loading'
import { lazy, Suspense } from 'react'

const Documents = lazy(() =>
  import('@pages/documents/documents').then((module) => ({
    default: module.Documents,
  })),
)

export const DocumentsRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <Documents />
  </Suspense>
)
